export default __webpack_public_path__ + "static/media/layout-grid.853ad49c.svg";